import { Component } from '@angular/core';
import { CurrencyViewService } from 'src/app/core/services/general/currency-view.service';

/**
 * "You are looking at the ZiG book" — stated on the PAGE, not inside the control.
 *
 * Separate from {@see CurrencyViewChoiceComponent} for a layout reason that turned out to matter: the
 * control sits in the header's flex row beside the date filter, and a banner rendered inside it pushed
 * that filter onto a second line. Header controls belong on one line; the sentence belongs under the
 * page title where there is room for it.
 *
 * It is said at all because a non-base screen must never be mistaken for a dollar one by a reader who
 * did not look at the filter — and with no exchange rate in this system, that mistake is not a
 * cosmetic one.
 */
@Component({
  selector: 'app-currency-view-banner',
  template: `
    <div class="cv-banner" *ngIf="shows">
      <i class="bi bi-info-circle"></i>
      Showing the <strong>{{ book }}</strong> book — figures below are {{ book }} only.
    </div>
  `,
  styles: [`
    .cv-banner {
      display: inline-flex;
      align-items: center;
      gap: .45rem;
      margin: .35rem 0 0;
      padding: .3rem .65rem;
      border-radius: .35rem;
      font-size: .76rem;
      color: #205370;
      background: #eef3f8;
      border: 1px solid #d0d7e2;
    }
  `],
})
export class CurrencyViewBannerComponent {
  constructor(private currencyView: CurrencyViewService) {}

  /** Only when a non-base book is in view — the base needs no announcement. */
  get shows(): boolean {
    return this.currencyView.asks && !this.currencyView.isBase;
  }

  get book(): string {
    return this.currencyView.book;
  }
}
